import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { I18nProvider } from "./i18n";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Gateways from "./pages/Gateways";
import Investment from "./pages/Investment";
import Network from "./pages/Network";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function SiteLayout({ children }) {
  return (
    <>
      <Nav />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center bg-[#062029] text-[#C5A880] font-serif-display text-2xl">SBG</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <SmoothScroll />
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
              <Route path="/services" element={<SiteLayout><Services /></SiteLayout>} />
              <Route path="/gateways" element={<SiteLayout><Gateways /></SiteLayout>} />
              <Route path="/investment" element={<SiteLayout><Investment /></SiteLayout>} />
              <Route path="/network" element={<SiteLayout><Network /></SiteLayout>} />
              <Route path="/about" element={<SiteLayout><About /></SiteLayout>} />
              <Route path="/contact" element={<SiteLayout><Contact /></SiteLayout>} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
